import { Alignment, Position } from './types';

export const ALIGNMENTS: Alignment[] = ['top', 'bottom', 'start', 'end', 'center'];
export const POSITIONS: Position[] = ['above', 'below', 'before', 'after'];
